import React, { Suspense, lazy } from 'react';
import { Route, Switch } from 'react-router-dom';
import { SuspenseSpinner } from './withLazyComponent';

interface RootRouterProps {
  routes: Array<{ path: string; component: React.FC | Promise<any>; isLazy?: boolean }>;
}

const lazyImportComponent = (componentPath: any) => {
  return lazy(() => componentPath);
};

function RootRouter(props: RootRouterProps) {
  return (
    <Switch>
      {props.routes.map((route, index) => {
        return route.isLazy ? (
          <Route
            path={route.path}
            key={route.path}
            render={() => {
              const Component = lazyImportComponent(route.component);

              return (
                <Suspense fallback={<SuspenseSpinner />}>
                  <Component />
                </Suspense>
              );
            }}
          ></Route>
        ) : (
          <Route
            path={route.path}
            key={route.path}
            component={() => {
              const Component = route.component as React.FC;

              return <Component />;
            }}
          ></Route>
        );
      })}
    </Switch>
  );
}

export default RootRouter;
